import { ReactNode, useCallback, useState } from 'react';
import { useBoolean } from '@shared/util/hooks';
import { useUpgrade } from '../metricsCounter/useUpgrade';
import { UpgradeContent, UpgradeContentProps, UpgradeModal } from './UpgradeModal';
import { type ShowModalOptions, UpgradeModalContextProvider } from './context';

interface Props {
  children: ReactNode;
}

export function UpgradeModalProvider({ children }: Props) {
  const [modalProps, setModalProps] = useState<ShowModalOptions>({
    title: '',
    description: '',
    onLearnMore: undefined,
    header: undefined,
    hideUpgradeButton: false,
  });
  const upgrade = useUpgrade();
  const [isOpen, open, close] = useBoolean();

  const show = useCallback(
    ({
      title,
      description,
      header = undefined,
      hideUpgradeButton,
      onLearnMore,
    }: ShowModalOptions) => {
      setModalProps({ title, description, header, hideUpgradeButton, onLearnMore });
      open();
    },
    [open],
  );

  return (
    <UpgradeModalContextProvider value={{ show }}>
      {children}
      <UpgradeModal
        isOpen={isOpen}
        onOpenChange={close}
        onUpgrade={modalProps.hideUpgradeButton ? () => {} : upgrade}
        {...modalProps}
      />
    </UpgradeModalContextProvider>
  );
}

export function UpgradeInlineContent({
  hideUpgradeButton,
  ...props
}: Omit<UpgradeContentProps, 'onUpgrade'> & { hideUpgradeButton?: boolean }) {
  const upgrade = useUpgrade();
  return <UpgradeContent {...props} onUpgrade={hideUpgradeButton ? undefined : upgrade} />;
}
